const state = {
  message: null,
  color: null,
  timeout: null,
  isVisible: false
}

const actions = {
  success ({ commit }, message) {
    commit('clear')
    setTimeout(() => { commit('success', message) }, 100)
  },

  error ({ commit }, message) {
    commit('clear')
    setTimeout(() => { commit('error', message) }, 100)
  },

  info ({ commit }, message) {
    commit('clear')
    setTimeout(() => { commit('info', message) }, 100)
  },

  default ({ commit }, message) {
    commit('clear')
    setTimeout(() => { commit('default', message) }, 100)
  },

  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  success (state, message) {
    state.color = 'success'
    state.message = message
    state.isVisible = true
  },

  default (state, message) {
    state.color = null
    state.message = message
    state.isVisible = true
  },

  error (state, message) {
    state.color = 'error'
    state.message = message
    state.isVisible = true
  },

  info (state, message) {
    state.color = 'info'
    state.message = message
    state.isVisible = true
  },

  clear (state) {
    state.type = null
    state.message = null
    state.isVisible = false
  }
}

const snackbarAlert = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default snackbarAlert
